export const MIN_ZOOM_SCALE = 1;
export const MAX_ZOOM_SCALE = 3;
export const ZOOM_STEP = 0.25;
export const MAX_PINCH_ZOOM_DELTA_PER_FRAME = 0.05;
export const TRACKPAD_WHEEL_ZOOM_SENSITIVITY = 0.01;
export const TRACKPAD_WHEEL_IDLE_MS = 120;
